<mat-dialog-content class="mat-dialog-content modal__window modal__window--error">

  <div class="box__heading box__heading--arrow">
    <h3 translate>errors.application.title.one</h3>
    <mat-icon matSuffix class="mat-icon material-icons modal__window--close"
              (click)="dialogRef.close()">close</mat-icon>
  </div>

  <div class="modal__window--content">

    <!-- Default message -->
    @if (!useResponseCode) {
    <div translate>errors.response.unauthorized</div>
    }

    <!-- By Response Code -->
    @if (useResponseCode) {
    <div>
      {{'errors.response.code.' + responseCode | translate}}
    </div>
    }

  </div>

  <div class="form__actions">
    <div class="form__buttons">
      <button class="btn btn__primary" type="submit" (click)="dialogRef.close(true)" tabindex="0"
              translate>
        common.ok
      </button>
    </div>
  </div>

</mat-dialog-content>
